var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[(!_vm.loading)?_c(this.$route.meta.layout || 'MainLayout',{tag:"component"},[_c('router-view',{on:{"showModal":_vm.modal}}),_c('Modals',{ref:"globalModal"})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }